import { render, staticRenderFns } from "./TextAreaWidget.vue?vue&type=template&id=c79edef4"
import script from "./TextAreaWidget.vue?vue&type=script&lang=js"
export * from "./TextAreaWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports